import slugify from "slugify";

export const enableAnchorOnComponents = (layoutData) => {
  const ancora = layoutData?.ancora;
  if (ancora?.ancoraBlocco && ancora?.titoloAncora) {
    return {
      id: slugify(ancora.titoloAncora, { lower: true, strict: true }),
    };
  }
  return null;
};
